<template>
    <div>
        <!-- Selected items UI -->
        <q-input
            ref="input"
            @click="showDialog = true"
            @clear="clearSelection"
            v-model="selectedItemName"
            :input-class="{
                disable: 'table-select-input__disabled'
            }"
            :input-style="'cursor: pointer;'"
            :disable="disable"
            :label="label"
            :dense="dense"
            :rules="validationRules"
            :clearable="clearable"
            lazy-rules
            outlined
            :readonly="true"
            bg-color="white"
            color="accent"
        >
            <template v-slot:after>
                <slot name="input"></slot>
            </template>
        </q-input>

        <!-- Dialog -->
        <q-dialog v-model="showDialog">
            <q-card
                class="dialog"
                :class="$q.screen.gt.lg ? 'dialog__lg' : 'dialog__xs'"
            >
                <!-- Dialog header -->
                <q-bar class="bg-primary">
                    <div class="text-white">
                        {{ dialogTitle }}
                    </div>

                    <q-space />

                    <q-btn
                        @click="close"
                        class="text-white"
                        icon="close"
                        dense
                        flat
                    >
                        <q-tooltip>{{ $t('Close') }}</q-tooltip>
                    </q-btn>
                </q-bar>

                <!-- Reload options -->
                <q-card-section v-if="loadingOptionsFailed">
                    <q-banner inline-actions class="text-black outline">
                        {{
                            $t(
                                'Failed to load items due to an unexpected error. Click on the button to reload options.'
                            )
                        }}
                        <template v-slot:action>
                            <q-btn
                                @click="getItems"
                                :loading="isLoading"
                                :label="$t('Reload')"
                                color="primary"
                            />
                        </template>
                    </q-banner>
                </q-card-section>

                <!-- Table -->
                <q-card-section v-else>
                    <q-input
                        data-test="table-select-search-input"
                        v-model="search"
                        @clear="search = ''"
                        :placeholder="searchLabel"
                        color="accent"
                        class="q-mb-sm"
                        debounce="500"
                        clearable
                        outlined
                        dense
                    />
                    <q-table
                        @request="onRequest"
                        :rows="data"
                        :columns="columns"
                        :filter="search"
                        v-model:pagination="pagination"
                        :rows-per-page-options="[30]"
                        v-model:selected="selected"
                        :loading="isLoading"
                        :row-key="rowKey"
                        :no-data-label="noDataLabel || $t('No data available')"
                        :grid="cardMode"
                        table-class="sticky-table table-mode"
                        card-container-class="card-mode"
                        selection="single"
                        binary-state-sort
                        bordered
                        flat
                        hide-selected-banner
                    >
                        <!-- Card Mode -->
                        <template v-slot:item="props">
                            <slot name="item" :props="props"></slot>
                        </template>
                    </q-table>
                </q-card-section>

                <!-- Dialog actions -->
                <q-card-section
                    v-if="!loadingOptionsFailed"
                    class="q-px-lg q-pb-md float-right"
                >
                    <q-btn
                        id="table-select-cancel-button"
                        @click="close"
                        class="q-mr-md"
                        color="white"
                        text-color="primary"
                        outline
                        >{{ $t('Cancel') }}</q-btn
                    >
                    <q-btn
                        id="table-select-confirm-button"
                        @click="confirm"
                        color="primary"
                        >{{ $t('Confirm') }}</q-btn
                    >
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
import TableSelectMixin from '@mixins/TableSelectMixin.vue';

export default {
    name: 'TableSelect',
    mixins: [TableSelectMixin]
};
</script>

<style lang="scss" scoped>
// remove the scroll bar on the dialog

.dialog__lg {
    width: 50%;
    max-width: none;
}
.dialog__xs {
    width: 100%;
    max-width: none;
}
// scroll area for the cards container of the component
:deep(.card-mode) {
    max-height: 60vh;
    overflow-y: scroll;
}
// scroll area for the table rows part of the component
:deep(.table-mode) {
    height: 55vh;
}
</style>
